export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/app-store-badge-white.027d3165.svg","height":48,"width":129};